.buttonsContainer {
    grid-auto-columns: max-content;
}
